export const getApiUrl = (): string => process.env.REACT_APP_API_URL ?? window.origin;
